<style scoped></style>
<template>
  <swiper-content isProduct :contentEnabled="contentEnabled">
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout page-layout-product">
          <page-video
            :contentEnabled="contentEnabled"
            videoSrc="videos/watch6-video.mp4"
          ></page-video>
          <div class="content">
            <img
              src="./products/watch6-logo.svg"
              class="product-logo"
              style="margin-top: -1vh; max-width: 25%"
            />

            <h2>The future of health is on your wrist.</h2>

            <p>
              With a new sensor and app to measure blood oxygen, the ECG app and
              other advanced health features, Apple Watch Series 6 is the watch
              that watches over you.
            </p>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/accessories?deal=singtel:rrp/rrp-accessory-deals/apple-watch&utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=applewatch-series6-buynow&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Buy Now
            </a>
            <a
              target="_blank"
              href="https://www.singtel.com/personal/products-services/mobile/info/applewatch-series6?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=applewatch-series6-learnmore&utm_campaign=iphone-2020-launch"
              class="st-button-red-outline page-button"
            >
              Learn More
            </a>

            <p class="small">T&amp;Cs apply.</p>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  name: "Watch6Page",
  data: function () {
    return {};
  },
  props: {
    contentEnabled: Boolean,
  },
  methods: {},
};
</script>

<style scoped></style>
